import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from '../service.model';
import { ServicesService } from '../services.service';
import { Observable } from 'rxjs';
import { SEOService } from '@data/services/meta-data.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-service-item',
  templateUrl: './service-item.component.html',
  styleUrls: ['./service-item.component.scss'],
})
export class ServiceItemComponent implements OnInit {
  page$: Observable<Service>;

  @ViewChild('content') content: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private serviceService: ServicesService,
    private seoService: SEOService
  ) {}

  ngOnInit(): void {
    const param = this.route.snapshot.paramMap.get('category');
    this.page$ = this.serviceService.getSingle(param).pipe(
      tap((page) => {
        this.setSeoData(page);
      })
    );
  }

  setSeoData(service: Service): void {
    this.seoService.setMetaData(service.metaTitle, service.metaDescription);
  }

  onContainerScroll(we: WheelEvent) {
    if (we.deltaY > 0) {
      this.content.nativeElement.scrollTop += 500;
    } else {
      this.content.nativeElement.scrollTop -= 500;
    }
  }
}
